/**
 * 文件卡片分享
 */
import React, { useCallback, useMemo, useEffect } from "react";
import { MessageStatus, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import styles from "./index.module.less";
import Context from "@/components/chat/context";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getJoySpacePageLink } from "@jd/focus-desktop-comps/lib/es/utils";
import DownloadService from "@/server/DownloadService";
import { isArray } from "lodash";
import { preivewFileWPS } from "@/utils/chat/message";
import { canJoyspacePreview } from "@/components/Joyspace/util";
import { downLoadFile } from "@/utils/chat/index";

interface IProps {
  message: any;
  sessionType: SessionType;
  sendType: MessageSendType;
  beginSend?: boolean;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
}

function FileLinkCard(props: IProps) {
  const { message, onReady, sendType } = props;
  const { currentEmployee, userData } = React.useContext(Context);
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const {
    fileService: { imAppKey },
    joyspaceHost,
    joyspaceApiHost
  } = appRuntimeEnv;

  const dataInfo = useMemo(() => {
    let files = lodashGet(message, "data.0.files", []);
    files = isArray(files) ? files : [];
    return files;
  }, [message]);
  // 发送
  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);

  const handleItemClick = useCallback(
    (item: any) => {
      const { fileUrl, fileType, fileKey, filename } = item;
      if (Number(fileType) === 2) {
        // 另存为
        if (canJoyspacePreview(filename)) {
          return preivewFileWPS({ appKey: imAppKey, downloadUrl: fileUrl }, { joyspaceHost });
        }
        return downLoadFile(filename, fileUrl);
      } else {
        // 打开文档
        window.open(
          getJoySpacePageLink(joyspaceHost, {
            pageType: fileType,
            id: fileKey
          })
        );
      }
    },
    [imAppKey, joyspaceHost]
  );

  return (
    <div className="content">
      <div className={styles["share-file-item"]} style={{ alignItems: "flex-start" }}>
        <div className={styles["text"]}>{message.content}</div>
        {dataInfo?.map((d: any, idx: number) => {
          return (
            <div
              className={styles["file-item"]}
              key={`card-file-${message.id}_${idx}`}
              onClick={() => handleItemClick(d)}
            >
              <img
                className={styles["icon"]}
                src={`${joyspaceApiHost}/v1/common/icons?title=${encodeURIComponent(
                  d.filename
                )}&pageType=${Number(d.fileType) === 1 ? d.fileType : 6}&client=web`}
              />

              <span className={`${styles["name"]} ellipsis`}>{d?.filename}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FileLinkCard;
